import { FC } from 'react';
import { useHomeStore } from '@/store/home';
import { DirectionrightIcon, PlacardIcon } from '@bfe/moly-icons';
import { openLink, domainAbsolutePathReplace } from '@web3/base-utils';
import { useScreenType } from '@web3/base-hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import styles from './index.module.scss';

export const Tips: FC = () => {
  const { notices } = useHomeStore();
  const { isMobile } = useScreenType();

  if (!notices || notices.length === 0) {
    return null;
  }

  return (
    <div className={styles.tips}>
      <Swiper
        // effect="cube"
        direction="vertical"
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay]}
      >
        {notices.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div
                className={styles.content}
                onClick={() => {
                  if (isMobile) {
                    openLink(item.appGoUrl);
                    return;
                  }
                  window.open(domainAbsolutePathReplace(item.webGoUrl));
                }}
              >
                <PlacardIcon className={styles.leftIcon} />
                <span className={styles.text}>{item.content}</span>
                <DirectionrightIcon className={styles.rightIcon} />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Tips;
